/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseUpdateRequestState } from './courseUpdateRequestState';
import type { CourseUpdateRequestIsDeprecated } from './courseUpdateRequestIsDeprecated';
import type { CourseUpdateRequestExternalProductId } from './courseUpdateRequestExternalProductId';
import type { CourseUpdateRequestSegments } from './courseUpdateRequestSegments';

/**
 * update course request
 */
export interface CourseUpdateRequest {
  title: string;
  description?: string;
  ects?: number;
  state?: CourseUpdateRequestState;
  isDeprecated?: CourseUpdateRequestIsDeprecated;
  externalProductId?: CourseUpdateRequestExternalProductId;
  segments?: CourseUpdateRequestSegments;
}
